import React, { useMemo } from 'react';

import { Image, ImageProps } from 'expo-image';
import { ImageSourcePropType, ImageStyle, StyleProp, StyleSheet } from 'react-native';

import { getImageAspectRatio } from './image-dimensions';

type FullWidthImageProps = ImageProps & {
  style?: StyleProp<ImageStyle>;
};

/** a full width image component that automatically determines its height */
export const FullWidthAutoHeightImage: React.FC<FullWidthImageProps> = ({
  source,
  style,
  ...rest
}) => {
  const aspectRatio = useMemo(() => getImageAspectRatio(source as ImageSourcePropType), [source]);

  const fullWidthStyle: StyleProp<ImageStyle> = [
    styles.image,
    aspectRatio ? { aspectRatio } : {},
    style,
  ];

  return <Image source={source} style={fullWidthStyle} {...rest} />;
};

export default FullWidthAutoHeightImage;

const styles = StyleSheet.create({ image: { width: '100%' } });
